/**
 * @generated SignedSource<<4d4aeaedb242a23759b6b19b9f0cda83>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentMethodSelectOptions_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PayPalPaymentMethod_buyer" | "WalletPaymentMethod_buyer">;
  readonly " $fragmentType": "PaymentMethodSelectOptions_buyer";
};
export type PaymentMethodSelectOptions_buyer$key = {
  readonly " $data"?: PaymentMethodSelectOptions_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentMethodSelectOptions_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentMethodSelectOptions_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WalletPaymentMethod_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PayPalPaymentMethod_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "72bc08008cb40d11787a29f17a34648c";

export default node;
